document.addEventListener('DOMContentLoaded', function () {
  const videoFrames = document.querySelectorAll(
    '.sc-pdp-video iframe[data-sc-youtube-src]'
  );

  if (!videoFrames.length) return;

  videoFrames.forEach(function (iframe) {
    const videoSrc = iframe.getAttribute('data-sc-youtube-src');
    if (!videoSrc) return;

    const match = videoSrc.match(/youtube\.com\/embed\/([^?&"']+)/);
    if (!match || !match[1]) return;

    const videoId = match[1];

    const wrapper = document.createElement('button');
    wrapper.type = 'button';
    wrapper.className = 'sc-pdp-video-lite';
    wrapper.setAttribute(
      'aria-label',
      iframe.getAttribute('title') || 'Play product video'
    );

    const thumbnail = document.createElement('img');
    thumbnail.src = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
    thumbnail.alt = '';
    thumbnail.loading = 'lazy';
    thumbnail.width = 480;
    thumbnail.height = 360;

    const playButton = document.createElement('span');
    playButton.className = 'sc-pdp-video-lite__play';
    playButton.setAttribute('aria-hidden', 'true');

    wrapper.appendChild(thumbnail);
    wrapper.appendChild(playButton);

    wrapper.addEventListener('click', function () {
      const liveIframe = document.createElement('iframe');

      liveIframe.src =
        videoSrc +
        (videoSrc.includes('?') ? '&' : '?') +
        'autoplay=1';

      liveIframe.title =
        iframe.getAttribute('title') || 'Product video';

      liveIframe.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';

      liveIframe.allowFullscreen = true;
      liveIframe.loading = 'eager';

      wrapper.replaceWith(liveIframe);
    });

    iframe.replaceWith(wrapper);
  });
});